<template>
  <li class="list-group-item d-flex align-items-center justify-content-between">
    <div class="d-flex wd-60p">
      <img :src="`${source.av}`" class="wd-30 rounded-circle mg-r-10" alt="" />
      <div :title="source.dp">
        <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ source.l }}</h6>
        <span class="d-block tx-11 text-muted">{{ source.ps }}</span>
      </div>
    </div>
    <div class="text-muted mg-l-15">{{ source.un }}</div>
    <button
      @click="$parent.$parent.$emit('on-action', source.id)"
      class="btn btn-xs btn-outline-light mg-l-auto"
    >
      <feather type="user-plus"></feather>
      Томилох
    </button>
  </li>
</template>

<script>
export default {
  name: "item-component",
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
